<ion-card
  *ngIf="!reduced && !appService.isMobile(); else fileReduced"
  class="flex flex-col"
  [ngStyle]="{
    width: preview ? '281px' : '',
  }"
>
  <!-- HEADER -->
  <div class="card-header flex flex-row items-center justify-between" [class.disabled]="isLoading">
    <div class="flex flex-row items-center gap-2.5">
      <ion-icon cdkDragHandle *ngIf="!isLoading" class="move-icon" icon="assets/icon/move.svg"></ion-icon>
      <span class="file-index">Posición {{ index + 1 }}</span>
    </div>
    <div>
      <ion-button
        class="action-button"
        fill="clear"
        color="dark"
        size="small"
        (click)="duplicate()"
        tooltip="Duplicar documento"
      >
        <ion-icon class="action-button_icon" icon="assets/icon/duplicate.svg"></ion-icon>
      </ion-button>
      <ion-button
        class="action-button"
        fill="solid"
        color="danger"
        size="small"
        (click)="borrar()"
        tooltip="Eliminar documento"
        tooltipClass="red-tooltip"
      >
        <ion-icon class="action-button_icon" icon="assets/icon/eliminar.svg"></ion-icon>
      </ion-button>
    </div>
  </div>
  <div class="flex h-full flex-col justify-between">
    <div class="w-100 my-[10px] flex flex-col md:flex-row">
      <!-- VISUALIZADOR -->
      <div
        class="fileCols flex flex-wrap items-center justify-center"
        [ngClass]="{ 'w-1/2': !preview, 'w-100': preview }"
      >
        <ng-container *ngIf="fileUploaded?.thumbFile; else loading">
          <div class="thumbnailDiv">
            <!-- BLANK PAGE -->
            <div
              #targetElement
              *ngIf="pFile.blankSheetsBefore"
              class="counterImage before"
              [ngClass]="{
                'folio-portrait': fileSettings.pageOrientation === PageOrientation.PORTRAIT,
                'folio-landscape': fileSettings.pageOrientation === PageOrientation.LANDSCAPE,
                'folio-large-side': fileSettings.pageTurn === PageTurn.LARGESIDE,
              }"
            >
              <div class="sheetNumber">
                <span>
                  {{ pFile.blankSheetsBefore || 0 }} folio{{ pFile.blankSheetsBefore !== 1 ? 's blancos' : ' blanco' }}
                  DELANTE
                </span>
              </div>

              <img
                *ngIf="fileSettings.pageOrientation === PageOrientation.PORTRAIT"
                [src]="'/assets/icon/blank-folio.svg'"
              />
              <img
                *ngIf="fileSettings.pageOrientation === PageOrientation.LANDSCAPE"
                [src]="'/assets/icon/blank-folio-landscape.svg'"
              />
            </div>
            <!-- DOC -->
            <div class="img-container">
              <div class="finishings-decorators">
                <div
                  class="finishing-decorators_container"
                  [ngClass]="{
                    portrait: fileSettings.pageOrientation === PageOrientation.PORTRAIT,
                    landscape: fileSettings.pageOrientation === PageOrientation.LANDSCAPE,
                    'large-side': fileSettings.pageTurn === PageTurn.LARGESIDE,
                  }"
                >
                  <ion-icon
                    *ngIf="
                      fileSettings.finishing === Finishing.BINDING &&
                      !fileSettings.coverLaminated &&
                      fileSettings.pageSize !== PageSize.A3
                    "
                    class="binding-cover"
                    [ngStyle]="{
                      fill:
                        fileSettings.hardCoverFront.color === '#FFFFFF' ? '#CCCCCC' : fileSettings.hardCoverFront.color,
                      opacity: fileSettings.hardCoverFront.id === 'transparent' ? 0.25 : 0.85,
                    }"
                    src="assets/images/thumbnail-finishings/cover.svg"
                  ></ion-icon>
                  <ion-icon
                    *ngIf="
                      fileSettings.finishing === Finishing.BINDING ||
                      fileSettings.finishing === Finishing.BINDING_LAMINATED
                    "
                    class="binding-holes"
                    [ngClass]="{
                      'large-side': fileSettings.pageTurn === PageTurn.LARGESIDE,
                      landscape: fileSettings.pageOrientation === PageOrientation.LANDSCAPE,
                    }"
                    [src]="getBindingSrc('holes')"
                  ></ion-icon>
                  <ion-icon
                    *ngIf="
                      fileSettings.finishing === Finishing.BINDING ||
                      fileSettings.finishing === Finishing.BINDING_LAMINATED
                    "
                    class="binding-rings"
                    [ngClass]="{
                      'large-side': fileSettings.pageTurn === PageTurn.LARGESIDE,
                      landscape: fileSettings.pageOrientation === PageOrientation.LANDSCAPE,
                    }"
                    [ngStyle]="{
                      fill: fileSettings.ringColor.color === '#FFFFFF' ? '#CCCCCC' : fileSettings.ringColor.color,
                    }"
                    [src]="getBindingSrc('rings')"
                  ></ion-icon>

                  <ion-icon
                    *ngIf="fileSettings.finishing === Finishing.STAPLED"
                    class="stapled"
                    src="assets/images/thumbnail-finishings/stapled.svg"
                  ></ion-icon>
                  <ion-icon
                    *ngIf="fileSettings.finishing === Finishing.PERFORATED2"
                    class="perforated2"
                    src="assets/images/thumbnail-finishings/2-holes.svg"
                  ></ion-icon>
                  <ion-icon
                    *ngIf="fileSettings.finishing === Finishing.PERFORATED4"
                    class="perforated4"
                    src="assets/images/thumbnail-finishings/4-holes.svg"
                  ></ion-icon>
                  <ion-icon
                    *ngIf="
                      fileSettings.finishing === Finishing.LAMINATED ||
                      fileSettings.coverLaminated ||
                      fileSettings.finishing === Finishing.BINDING_LAMINATED
                    "
                    class="laminated"
                    src="assets/images/thumbnail-finishings/laminated.svg"
                  ></ion-icon>
                </div>
              </div>
              <ng-container *ngIf="file.pdfImages; else elseTemplateImg">
                <lib-thumbnail-pdf
                  *ngIf="printingGroup.printSettings"
                  [printSettingsThumb]="fileSettings"
                  [settingsChanged]="settingsChanged"
                  [pdfImages]="file.pdfImages"
                ></lib-thumbnail-pdf>
              </ng-container>
              <ng-template #elseTemplateImg>
                <img [src]="fileUploaded?.thumbFile?.url" />
              </ng-template>
            </div>
            <!-- BLANK PAGE -->
            <div
              *ngIf="pFile.blankSheetsAfter"
              class="counterImage after"
              [ngClass]="{
                'folio-portrait': fileSettings.pageOrientation === PageOrientation.PORTRAIT,
                'folio-landscape': fileSettings.pageOrientation === PageOrientation.LANDSCAPE,
                'folio-large-side': fileSettings.pageTurn === PageTurn.LARGESIDE,
              }"
            >
              <div class="sheetNumber">
                <span>
                  {{ pFile.blankSheetsAfter || 0 }} folio{{ pFile.blankSheetsAfter !== 1 ? 's blancos' : ' blanco' }}
                  DETRÁS
                </span>
              </div>
              <img
                *ngIf="fileSettings.pageOrientation === PageOrientation.PORTRAIT"
                [src]="'/assets/icon/blank-folio.svg'"
              />
              <img
                *ngIf="fileSettings.pageOrientation === PageOrientation.LANDSCAPE"
                [src]="'/assets/icon/blank-folio-landscape.svg'"
              />
            </div>
          </div>
        </ng-container>
      </div>
      <!-- OPCIONES DE LA DERECHA -->
      <div *ngIf="!preview" class="fileCols flex w-1/2" [class.disabled]="isLoading">
        <div class="w-100 flex flex-col gap-2">
          <!-- OPCION DE PORTADA -->
          <ng-container *ngIf="printingGroup.printSettings.finishing !== Finishing.LAMINATED">
            <div
              class="cover laminated-cover flex flex-row items-center justify-between"
              (click)="openCoverSettings()"
              *ngIf="hasToShowCoverSettings"
            >
              <div class="w-100 flex flex-row items-center">
                <img [src]="fileService.getCoverTypeImage(currentCoverTypeData.value, fileSettings)" alt="" />
                <div class="w-100 flex flex-col">
                  <div class="flex flex-row items-center justify-between">
                    <div class="flex flex-col">
                      <span class="file-text bold">
                        {{ currentCoverTypeData?.title }}
                        <span *ngIf="!pFile.coverLaminated">({{ pFile.coverType?.paperWeight }} gr)</span>
                      </span>
                      <span
                        *ngIf="
                          !hasToShowDespaginationToggle &&
                          fileService.getDefaultCoverType(pFile, printingGroup.printSettings)?.id ===
                            pFile.coverType?.id
                        "
                        class="file-text"
                      >
                        Seleccionada por defecto
                      </span>
                    </div>
                    <ion-icon
                      *ngIf="hasToShowDespaginationToggle"
                      class="info-icon"
                      color="black"
                      #despaginationIcon
                      src="assets/icon/alert-red-circle.svg"
                      (click)="openDespaginationInfoModal()"
                    ></ion-icon>
                    <ion-popover #despaginationPopover class="despagination-popover" showBackdrop="false">
                      <ng-template>
                        <ion-content class="ion-padding">
                          Después de imprimir la portada por la cara frontal, la cara trasera de esa misma hoja se deja
                          sin imprimir, quedando completamente en blanco.
                        </ion-content>
                      </ng-template>
                    </ion-popover>
                  </div>

                  <ion-toggle
                    *ngIf="hasToShowDespaginationToggle"
                    class="despagination-toggle"
                    [checked]="!pFile.coverType.twoSided"
                    (ionChange)="changeDespagination($event)"
                  >
                    Despaginación activada
                  </ion-toggle>
                </div>
              </div>
              <ion-icon *ngIf="!hasToShowDespaginationToggle" icon="assets/icon/flechaDerecha.svg"></ion-icon>
            </div>
          </ng-container>
          <!-- OPCION TINTA NEGRA O COLOR -->
          <div class="container-type flex flex-col" cover>
            <span class="file-text bold">Documento en:</span>
            <div class="color flex flex-row items-center">
              <ion-radio-group
                [value]="fileSettings.docColor ? 'color' : 'bn'"
                (ionChange)="changeDocColor($event)"
                class="flex gap-4 sm:flex-row lg:flex-row xl:flex-row 2xl:gap-4"
              >
                <ion-radio mode="md" labelPlacement="end" justify="start" value="bn" class="file-text"
                  >Blanco y negro
                </ion-radio>
                <ion-radio mode="md" labelPlacement="end" justify="start" value="color" class="file-text"
                  >A Color
                </ion-radio>
              </ion-radio-group>
            </div>
          </div>
          <!-- OPCION PORTADA PASTIFICADA -->
          <ng-container *ngIf="printingGroup.printSettings.finishing === Finishing.LAMINATED">
            <app-lamination-options
              [file]="pFile"
              [settings]="settings"
              [laminationType]="pFile.laminationType"
              [laminationWeight]="pFile.laminationWeight"
              (finalValues)="refreshFilePrice()"
              [inFile]="true"
            >
            </app-lamination-options>
          </ng-container>
          <!-- OPCION ENCUADERNADO -->
          <div
            [ngStyle]="{
              display: [Finishing.BINDING, Finishing.BINDING_LAMINATED].includes(printingGroup.printSettings.finishing)
                ? 'flex'
                : 'none',
            }"
            class="binding container-type flex flex-row items-center justify-between"
            (click)="openIndividualBindingSettings()"
          >
            <div class="flex flex-col gap-1">
              <!-- TIPO DE PLASTIFICADO -->
              <div
                *ngIf="fileSettings.coverLaminated || fileSettings.finishing === Finishing.BINDING_LAMINATED"
                class="flex flex-row items-center"
              >
                <img src="../../../assets/images/finishings/plastificado.svg" alt="" />
                <div class="flex flex-col">
                  <div class="flex flex-row gap-0">
                    <span class="file-text bold">Tipo plastificado:</span>
                    <span class="file-text">{{ fileService.getLaminationTypeName(pFile.laminationType) }}</span>
                  </div>
                  <div class="flex flex-row gap-0">
                    <span class="file-text bold">Grosor:</span>
                    <span class="file-text"
                      >{{
                        fileService.getLaminationWeightName(
                          pFile.laminationWeight,
                          pFile.laminationType,
                          pFile.coverLaminated,
                          fileSettings.finishing === Finishing.BINDING_LAMINATED
                        )
                      }}
                      <span *ngIf="!pFile.coverLaminated && fileSettings.finishing !== Finishing.BINDING_LAMINATED"
                        >({{ pFile.laminationWeight }} micras)</span
                      ></span
                    >
                  </div>
                </div>
              </div>
              <!-- ANILLA -->
              <div class="flex flex-row items-center">
                <img [src]="'assets/images/binding/rings/' + fileSettings.ringColor.id + '.png'" alt="" />
                <span class="file-text bold">Anilla: </span>&nbsp;
                <span class="file-text">({{ fileSettings.ringColor.name }})</span>
              </div>
              <!-- TAPA DELANTERA -->
              <div
                *ngIf="
                  !fileSettings.coverLaminated &&
                  fileSettings.finishing !== Finishing.BINDING_LAMINATED &&
                  fileSettings.pageSize !== PageSize.A3
                "
                class="flex flex-row items-center"
              >
                <app-cover-thumbnail
                  [id]="fileSettings.hardCoverFront.id"
                  [color]="fileSettings.hardCoverFront.color"
                  [width]="'20px'"
                >
                </app-cover-thumbnail>
                <div class="flex flex-col items-start justify-center">
                  <span class="file-text bold">Tapa delantera:</span>
                  <span class="file-text overflow-hidden text-ellipsis whitespace-nowrap"
                    >({{ utils.getColorName(fileSettings.hardCoverFront.name) }})</span
                  >
                </div>
              </div>
              <!-- TAPA TRASERA -->
              <div
                class="flex flex-row items-center"
                *ngIf="fileSettings.finishing !== Finishing.BINDING_LAMINATED && fileSettings.pageSize !== PageSize.A3"
              >
                <app-cover-thumbnail
                  [id]="fileSettings.hardCoverBack.id"
                  [color]="fileSettings.hardCoverBack.color"
                  [width]="'20px'"
                >
                </app-cover-thumbnail>
                <div class="flex flex-col items-start justify-center">
                  <span class="file-text bold">Tapa trasera:</span>
                  <span class="file-text overflow-hidden text-ellipsis whitespace-nowrap"
                    >({{ utils.getColorName(fileSettings.hardCoverBack.name) }})</span
                  >
                </div>
              </div>
            </div>
            <ion-icon icon="assets/icon/flechaDerecha.svg"></ion-icon>
          </div>
          <!-- OPCION ENCUADERNADO FIN -->
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div *ngIf="!preview" class="file-footer w-100 flex flex-col" [class.disabled]="isLoading">
      <!-- OPCION FOLIOS EN BLANCO -->
      <ng-container
        *ngIf="![Finishing.LAMINATED, Finishing.BINDING_LAMINATED].includes(printingGroup.printSettings.finishing)"
      >
        <div class="file-number-copies-container w-100 flex flex-col gap-2">
          <div class="start flex flex-row items-center">
            <span class="file-text bold mr-2">Añadir folios en blanco:</span>
            <!-- TOOLTIP FOLIOS EN BLANCO -->
            <ion-icon
              [id]="'tooltip-info-num-blank-pages' + index"
              class="tooltip-icon-num-black-pages"
              src="assets/icon/info.svg"
            >
            </ion-icon>
            <ion-popover
              [trigger]="'tooltip-info-num-blank-pages' + index"
              class="info-popover"
              triggerAction="click"
              showBackdrop="true"
              animated="true"
            >
              <ng-template>
                <app-tooltip-info-num-blank-pages></app-tooltip-info-num-blank-pages>
              </ng-template>
            </ion-popover>
          </div>

          <div class="flex flex-row items-center gap-2">
            <div class="flex w-full flex-row items-center justify-between" *ngIf="!pFile.coverLaminated">
              <span class="file-text">
                Folios en blanco por
                <span class="whitespace-nowrap"
                  >DELANTE:
                  <span
                    class="number-counter"
                    *ngIf="
                      printingGroup.files[index].blankSheetsBefore !== null &&
                      printingGroup.files[index].blankSheetsBefore !== undefined
                    "
                  >
                    {{ printingGroup.files[index].blankSheetsBefore ?? 0 }}
                  </span>
                </span>
              </span>
              <app-qty-stepper
                [qty]="printingGroup.files[index].blankSheetsBefore ?? 0"
                (changes)="changeBlankSheetsQty($event, 'before')"
                [styleType]="'card'"
              ></app-qty-stepper>
            </div>
            <div class="flex w-full flex-row items-center justify-between">
              <span class="file-text">
                Folios en blanco por
                <span class="whitespace-nowrap"
                  >DETRÁS:
                  <span
                    class="number-counter"
                    *ngIf="
                      printingGroup.files[index].blankSheetsAfter !== null &&
                      printingGroup.files[index].blankSheetsAfter !== undefined
                    "
                  >
                    {{ printingGroup.files[index].blankSheetsAfter ?? 0 }}
                  </span>
                </span>
              </span>
              <app-qty-stepper
                [qty]="printingGroup.files[index].blankSheetsAfter ?? 0"
                (changes)="changeBlankSheetsQty($event, 'after')"
                [styleType]="'card'"
              ></app-qty-stepper>
            </div>
            <div class="w-full" *ngIf="pFile.coverLaminated"></div>
          </div>
        </div>
      </ng-container>
      <!-- EDITAR NOMBRE DOC + NUM PAGS -->
      <div class="flex flex-row items-center">
        <div class="file-container-input flex flex-row items-center">
          <input
            type="text"
            class="file-alias-input"
            [disabled]="isLoading"
            [(ngModel)]="pFile.alias"
            (focusout)="checkAlias($event)"
            (keyup.enter)="onEditFile(aliasInput.value); aliasInput.blur()"
            (focus)="onFocusFile()"
            (blur)="onBlurFile()"
            #aliasInput
          />
          <ion-button
            #editTooltip="tooltip"
            [id]="'tooltip-button-edit-file' + index"
            class="edit-button"
            size="small"
            [disabled]="isLoading"
            [ngClass]="{ 'edit-active': editAliasButton }"
            (click)="focusInput()"
            [tooltip]="'Editar nombre del documento'"
            [tooltipClass]="'white-tooltip'"
          >
            <span class="edit-button_save" *ngIf="editAliasButton; else showIcon">Guardar</span>

            <ng-template #showIcon>
              <ion-icon class="edit-button_icon" [src]="'assets/icon/pencil.svg'"></ion-icon>
            </ng-template>
          </ion-button>
        </div>
        <div class="flex min-w-[120px] flex-1 flex-row items-center justify-between">
          <div class="flex flex-row items-center">
            <div class="separator vertical"></div>
            <span class="file-footer_text">Nº Páginas: </span>
          </div>
          <span class="file-footer_pages">{{ fileUploaded?.pages }}</span>
        </div>
      </div>
      <!-- Precio del documento -->
      <!-- Sin agrupar: precio individual por documento -->
      <div
        class="card-price"
        *ngIf="
          !printingGroup.printSettings.grouped ||
          (![Finishing.BINDING, Finishing.BINDING_LAMINATED].includes(printingGroup.printSettings.finishing) &&
            (file.total ?? pFile.total) !== undefined)
        "
      >
        <span class="card-price_label">Precio</span>
        <span class="card-price_amount">{{
          file.total ?? pFile.total | currency: cartService.cart.price.cur : 'symbol' : '1.3-3'
        }}</span>
      </div>
      <!-- Agrupado: total de la carpeta solo en el primer archivo -->
      <div
        class="card-price"
        *ngIf="
          printingGroup.printSettings.grouped &&
          [Finishing.BINDING, Finishing.BINDING_LAMINATED].includes(printingGroup.printSettings.finishing) &&
          index === 0 &&
          printProduct?.product?.unitPrice?.amt !== undefined
        "
      >
        <span class="card-price_label">Precio</span>
        <span class="card-price_amount">{{
          printProduct?.price?.amt / printProduct?.qty | currency: cartService.cart.price.cur : 'symbol' : '1.3-3'
        }}</span>
      </div>
    </div>
  </div>
</ion-card>

<!-- CARD EN AGRUPACION -->
<ng-template #fileReduced>
  <ion-card class="reduced flex flex-row gap-8" *ngIf="!appService.isMobile(); else fileReducedMobile">
    <div class="flex flex-col items-center justify-evenly gap-1.5">
      <ion-icon cdkDragHandle *ngIf="!isLoading" class="move-icon" icon="assets/icon/move.svg"></ion-icon>
      <span class="index">{{ index + 1 }}</span>
    </div>
    <div class="thumbnailDiv" [ngStyle]="{ 'flex-grow': !fileUploaded?.thumbFile ? 1 : 'unset' }">
      <ng-container *ngIf="fileUploaded?.thumbFile; else loading">
        <div *ngIf="pFile.blankSheetsBefore" class="counterImage before reduced">
          <span class="sheetNumber reduced">{{ pFile.blankSheetsBefore || 0 }}</span>
          <ion-icon icon="/assets/icon/sheetWhite.svg"></ion-icon>
        </div>
        <div class="img-container">
          <ng-container *ngIf="file.pdfImages; else elseTemplateImg">
            <lib-thumbnail-pdf
              *ngIf="printingGroup.printSettings"
              [printSettingsThumb]="fileSettings"
              [settingsChanged]="settingsChanged"
              [pdfImages]="file.pdfImages"
            ></lib-thumbnail-pdf>
          </ng-container>
          <ng-template #elseTemplateImg>
            <img [src]="fileUploaded?.thumbFile?.url" />
          </ng-template>
        </div>
        <div *ngIf="pFile.blankSheetsAfter" class="counterImage after reduced">
          <span class="sheetNumber reduced">{{ pFile.blankSheetsAfter || 0 }}</span>
          <ion-icon icon="/assets/icon/sheetWhite.svg"></ion-icon>
        </div>
      </ng-container>
    </div>
    <div class="flex flex-col justify-evenly" [class.disabled]="isLoading">
      <input
        *ngIf="!appService.isMobile()"
        type="text"
        class="file-alias-input"
        [(ngModel)]="pFile.alias"
        (focusout)="checkAlias($event)"
      />
      <span>Nº Pag: {{ fileUploaded.pages }}</span>
    </div>
    <div class="flex flex-1 flex-col items-end justify-evenly" [class.disabled]="isLoading">
      <ion-button
        class="individual-settings-button"
        fill="solid"
        color="light"
        size="small"
        (click)="openIndividualSettings()"
      >
        <ion-icon class="settings-button_icon" icon="assets/icon/settings2.svg"></ion-icon>
      </ion-button>
      <div class="flex flex-row">
        <ion-button
          class="action-button"
          fill="clear"
          color="dark"
          size="small"
          (click)="duplicate()"
          tooltip="Duplicar documento"
        >
          <ion-icon class="action-button_icon" icon="assets/icon/duplicate.svg"></ion-icon>
        </ion-button>
        <ion-button
          class="action-button"
          fill="solid"
          color="danger"
          size="small"
          (click)="borrar()"
          tooltip="Eliminar documento"
          tooltipClass="red-tooltip"
        >
          <ion-icon class="action-button_icon" icon="assets/icon/eliminar.svg"></ion-icon>
        </ion-button>
      </div>
    </div>
  </ion-card>
</ng-template>

<!-- CARD EN AGRUPACION MOBILE -->
<ng-template #fileReducedMobile>
  <div class="card-wrapper-reduced-mobile">
    <div class="move-icon-container flex flex-row items-center justify-evenly gap-1.5">
      <ion-icon cdkDragHandle *ngIf="!isLoading" class="move-icon" icon="assets/icon/move.svg"></ion-icon>
      <span class="index">{{ index + 1 }}</span>
    </div>
    <div class="card-border-wrapper">
      <ion-card
        class="reduced flex flex-col justify-between"
        [class.showing-grouped-files]="!hideGroupedFiles && isGroupedBindingFirstItem"
      >
        <div class="card-main w-100 flex flex-row justify-between gap-5">
          <div class="thumbnailDiv flex flex-row gap-2">
            <ng-container *ngIf="fileUploaded?.thumbFile; else loading">
              <div class="img-container">
                <div *ngIf="pFile.blankSheetsBefore" class="counterImage before reduced">
                  <span class="sheetNumber reduced">{{ pFile.blankSheetsBefore || 0 }}</span>
                  <ion-icon icon="/assets/icon/sheetWhite.svg"></ion-icon>
                </div>
                <ng-container *ngIf="file.pdfImages; else elseTemplateImg">
                  <lib-thumbnail-pdf
                    *ngIf="printingGroup.printSettings"
                    [printSettingsThumb]="fileSettings"
                    [settingsChanged]="settingsChanged"
                    [pdfImages]="file.pdfImages"
                  ></lib-thumbnail-pdf>
                </ng-container>
                <ng-template #elseTemplateImg>
                  <img [src]="fileUploaded?.thumbFile?.url" />
                </ng-template>
                <div *ngIf="pFile.blankSheetsAfter" class="counterImage after reduced">
                  <span class="sheetNumber reduced">{{ pFile.blankSheetsAfter || 0 }}</span>
                  <ion-icon icon="/assets/icon/sheetWhite.svg"></ion-icon>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="flex flex-1 flex-col justify-evenly">
            <div class="file-container-input flex flex-row items-center">
              <input
                type="text"
                class="file-alias-input"
                [disabled]="isLoading"
                [(ngModel)]="pFile.alias"
                (focusout)="checkAlias($event)"
                (keyup.enter)="onEditFile(aliasInput.value); aliasInput.blur()"
                (focus)="onFocusFile()"
                (blur)="onBlurFile()"
                #aliasInput
              />
              <ion-button
                [id]="'tooltip-button-edit-file' + index"
                class="edit-button"
                size="small"
                [disabled]="isLoading"
                [ngClass]="{ 'edit-active': editAliasButton }"
                (click)="focusInput()"
                [tooltip]="'Editar nombre del documento'"
                [tooltipClass]="'white-tooltip'"
              >
                <span class="edit-button_save" *ngIf="editAliasButton; else showIcon">Guardar</span>

                <ng-template #showIcon>
                  <ion-icon class="edit-button_icon" [src]="'assets/icon/pencil.svg'"></ion-icon>
                </ng-template>
              </ion-button>
            </div>
            <span>Nº Páginas: {{ fileUploaded.pages }}</span>
          </div>
          <div class="flex flex-col items-end justify-between" [class.disabled]="isLoading">
            <ion-button
              class="action-button"
              fill="clear"
              color="dark"
              size="small"
              (click)="duplicate()"
              tooltip="Duplicar documento"
            >
              <ion-icon class="action-button_icon" icon="assets/icon/duplicate.svg"></ion-icon>
            </ion-button>
            <ion-button
              class="action-button"
              fill="solid"
              color="danger"
              size="small"
              (click)="borrar()"
              tooltip="Eliminar documento"
              tooltipClass="red-tooltip"
            >
              <ion-icon class="action-button_icon" icon="assets/icon/eliminar.svg"></ion-icon>
            </ion-button>
          </div>
        </div>
        <div
          class="card-footer flex flex-row items-center justify-between"
          (click)="openIndividualSettings()"
          [class.first-item-grouped-binding]="isGroupedBindingFirstItem"
        >
          <span class="footer-options-title"
            >Ver configuraciones <span *ngIf="isGroupedBindingFirstItem">comunes</span></span
          >
          <ion-button class="action-button no-box" fill="solid" color="light" size="small">
            <ion-icon class="settings-button_icon" icon="assets/icon/settings2.svg"></ion-icon>
          </ion-button>
        </div>
        <div
          *ngIf="isGroupedBindingFirstItem"
          class="card-footer flex flex-row items-center justify-between"
          (click)="toggleHideGroupedFiles()"
          [class.showing-grouped-files]="!hideGroupedFiles && isGroupedBindingFirstItem"
        >
          <span class="footer-options-title">Ver documentos agrupados</span>
          <ion-button class="action-button no-box" fill="solid" color="light" size="small">
            <ion-icon
              [ngStyle]="{
                transform: hideGroupedFiles ? 'rotate(180deg)' : 'none',
              }"
              class="settings-button_icon"
              icon="assets/icon/flechaAbajo.svg"
            ></ion-icon>
          </ion-button>
        </div>
      </ion-card>
    </div>
    <!-- Sin agrupar: precio individual por documento -->
    <div
      class="card-price"
      *ngIf="
        !printingGroup.printSettings.grouped ||
        (![Finishing.BINDING, Finishing.BINDING_LAMINATED].includes(printingGroup.printSettings.finishing) &&
          (file.total ?? pFile.total) !== undefined)
      "
    >
      <span class="card-price_label barlow">Precio1</span>
      <span class="card-price_amount league-spartan">{{
        file.total ?? pFile.total | currency: cartService.cart.price.cur : 'symbol' : '1.3-3'
      }}</span>
    </div>
    <!-- Agrupado: total de la carpeta solo en el primer archivo -->
    <div
      class="card-price"
      *ngIf="
        printingGroup.printSettings.grouped &&
        [Finishing.BINDING, Finishing.BINDING_LAMINATED].includes(printingGroup.printSettings.finishing) &&
        index === 0 &&
        printProduct?.product?.unitPrice?.amt !== undefined
      "
    >
      <span class="card-price_label barlow">Precio2</span>
      <span class="card-price_amount league-spartan">{{
        printProduct.product.unitPrice.amt | currency: cartService.cart.price.cur : 'symbol' : '1.3-3'
      }}</span>
    </div>
  </div>
</ng-template>

<!-- LOADING -->
<ng-template #loading>
  <ion-col *ngIf="!reduced" size="12">
    <!-- Animación de Estado -->
    <ion-row class="ion-justify-content-center ion-align-items-center">
      <ng-container *ngIf="!failed; else fail">
        <!-- *ngIf="file.pdfImages; -->

        <div class="animacionDiv">
          <lib-thumbnail-pdf
            class="preview"
            *ngIf="printingGroup.printSettings"
            [printSettingsThumb]="fileSettings"
            [settingsChanged]="settingsChanged"
            [pdfImages]="file.pdfImages"
          ></lib-thumbnail-pdf>

          <div
            [ngSwitch]="actualSubstatus"
            style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)"
          >
            <div *ngSwitchCase="substatus.CONVERTING">
              <ng-lottie [options]="convertingAnimationOptions"></ng-lottie>
            </div>
            <div *ngSwitchCase="substatus.COUNTING">
              <ng-lottie [options]="countingAnimationOptions"></ng-lottie>
            </div>
            <div *ngSwitchCase="substatus.THUMBNAIL">
              <ng-lottie [options]="thumbnailAnimationOptions"></ng-lottie>
            </div>
            <div *ngSwitchDefault>
              <ng-lottie [options]="uploadAnimationOptions"></ng-lottie>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #fail>
        <ng-lottie [options]="failedAnimationOptions"></ng-lottie>
      </ng-template>
    </ion-row>
  </ion-col>
  <ion-col size="12" style="margin-bottom: 40px">
    <!-- titulo -->
    <ion-row class="ion-justify-content-center">
      <p class="file-name">{{ file.file.name }}</p>
    </ion-row>

    <!-- mensaje y loading -->
    <ion-row class="ion-justify-content-center loading">
      <!-- Barra de carga -->
      <ion-progress-bar [color]="!failed ? 'secondary' : 'danger'" [value]="statusProgress"></ion-progress-bar>
      <!-- Mensaje -->
      <p [ngClass]="{ error: failed }">
        {{ !failed ? substatusMessage + '... ' : 'Error' }}
        <b *ngIf="uploadedFile && !reduced"> {{ uploadedFile | fileSize }} / {{ file.file.size | fileSize }} </b>
        <b *ngIf="fileUploaded.printProtected">: Archivo protegido contra impresión</b>
        <b *ngIf="fileUploaded.pswProtected">: Archivo protegido con contraseña</b>
      </p>
    </ion-row>
  </ion-col>
</ng-template>
